{
  "addons.addonList": "Elenco componenti aggiuntivi",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Crea e recupera la tua chiave API da questo link",
  "addons.ambientWeatherDescription": "Stazioni meteorologiche Ambient (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Chiave API",
  "addons.applicationKey": "Chiave applicazione",
  "addons.connect": "Connetti",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "Chiave API V2",
  "addons.davisDescription": "Stazioni meteo Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Recupera le tue chiavi API V2 da questo link",
  "addons.disconnect": "Disconnetti",
  "addons.ecowittCreateAndRetrieveKeys": "Crea e recupera sia una chiave API che una chiave dell'applicazione da questo collegamento",
  "addons.ecowittDescription": "Ecowitt fornisce stazioni meteorologiche Wi-Fi professionali, termometri esterni e interni wireless, monitor dell'umidità, pluviometri ad alta precisione, monitor della qualità dell'aria e altro ancora.",
  "addons.helpLink": "Come connettere {provider}",
  "addons.myAcuriteAccountOnHold": "Il tuo account è stato sospeso. Inserisci la tua password per ricollegare il tuo account",
  "addons.myAcuriteDescription": "AcuRite è il marchio di stazioni meteorologiche numero 1 nel Nord America. In qualità di leader nella tecnologia del tempo, della temperatura e del meteo, AcuRite ti fornisce informazioni dettagliate sul tuo ambiente interno ed esterno in modo che tu possa pianificare la tua giornata con sicurezza.",
  "addons.myAcuriteEnterCredentials": "Inserisci le tue credenziali My AcuRite per collegare il tuo account My AcuRite con SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Usa il tuo termostato Netatmo per cambiare la temperatura della tua casa, dal tuo letto o dall'altra parte del mondo.",
  "addons.netatmoThermostat": "Netatmo Termostato",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "La tua stazione meteo personale a casa",
  "addons.or": "o",
  "addons.providerAccountDisconnected": "La connessione al tuo servizio meteo è scaduta. Riconnettiti per riprendere gli aggiornamenti dei dati.",
  "addons.reconnect": "Riconnetti",
  "addons.weatherflowCreateToken": "Crea e recupera il tuo token da questo link",
  "addons.weatherflowTempestDescription": "Stazione meteo Tempest con anemometro e pluviometro integrati",
  "addons.wundergroundApiKey": "Chiave API",
  "addons.wundergroundDescription": "Weather Underground è una comunità globale di persone che collega i dati provenienti da sensori ambientali come stazioni meteorologiche e monitor della qualità dell'aria in modo da poter fornire i dati ricchi e iperlocali di cui hai bisogno per alimentare le tue passioni",
  "addons.wundergroundRetrieveApiKey": "Recupera la tua chiave API da questo link",
  "addons.wundergroundRetrieveStationId": "Recupera l'ID della tua stazione da questo link",
  "addons.wundergroundStationId": "Identificazione Stazione",
  "airQuality.airQuality": "Qualità dell'aria",
  "airQuality.airQualityIndex": "Indice di qualità dell'aria",
  "airQuality.aqiForecast": "Previsioni qualità dell'aria",
  "airQuality.co": "Monossido di carbonio",
  "airQuality.dailyForecast": "Previsioni giornaliere",
  "airQuality.details": "Dettagli",
  "airQuality.dominantPollutant": "Inquinante dominante",
  "airQuality.good": "Buona",
  "airQuality.goodDescription": "La qualità dell'aria è considerata soddisfacente e l'inquinamento atmosferico presenta un rischio minimo o nullo",
  "airQuality.hazardous": "Pericolosa",
  "airQuality.hazardousDescription": "Allerta sanitaria: tutti possono avere effetti più gravi sulla salute",
  "airQuality.indoorAirQuality": "Qualità aria interna",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Moderata",
  "airQuality.moderateDescription": "La qualità dell'aria è accettabile. Tuttavia, per alcuni inquinanti, può esserci un moderato problema di salute per un numero molto ridotto di persone che sono più sensibili all'inquinamento atmosferico.",
  "airQuality.no2": "Biossido d'azoto",
  "airQuality.o3": "Ozono",
  "airQuality.pm10": "Particelle con un diametro inferiore a 10 μm",
  "airQuality.pm25": "Particelle con un diametro inferiore a 2,5 μm",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Malsana per le persone sensibili all'inquinamento atmosferico.",
  "airQuality.sensitiveUnhealthyDescription": "Le persone più sensibili all'inquinamento atmosferico possono avere effetti sulla salute. È improbabile che il pubblico in generale ne risenta.",
  "airQuality.so2": "Biossido di zolfo",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Malsana",
  "airQuality.unhealthyDescription": "Tutti possono iniziare a risentire di effetti sulla salute. Le persone più sensibili all'inquinamento atmosferico possono avere effetti sulla salute più gravi.",
  "airQuality.veryUnhealthy": "Estremamente malsana",
  "airQuality.veryUnhealthyDezscription": "Avvertenze sanitarie di condizione di emergenza. L'intera popolazione ha maggiore probabilità di essere colpita.",
  "alerts.addAlert": "Aggiungi un avviso",
  "alerts.addCondition": "Aggiungi condizione",
  "alerts.alertAdded": "Avviso aggiunto con successo",
  "alerts.alertAuthorizationNotice": "Gli avvisi possono funzionare solo se si consente a SmartMixin di mostrare le notifiche",
  "alerts.alertDeleted": "Avviso eliminato con successo",
  "alerts.alertEdited": "Avviso modificato con successo",
  "alerts.alertName": "Nome dell'avviso",
  "alerts.alertWhen": "Voglio essere avvisato quando",
  "alerts.aqiGreaterThan": "AQI maggiore di",
  "alerts.aqiGreaterThanThreshold": "AQI superiore al valore limite di {value}{unit}",
  "alerts.aqiLessThan": "AQI minore di",
  "alerts.aqiLessThanThreshold": "AQI inferiore al valore limite di {value}{unit}",
  "alerts.atLeastOneCondition": "Devi aggiungere almeno una condizione",
  "alerts.co2GreaterThan": "CO2 maggiore di",
  "alerts.co2GreaterThanThreshold": "CO2 superiore al valore limite di {value}{unit}",
  "alerts.co2LessThan": "CO2 minore di",
  "alerts.co2LessThanThreshold": "CO2 inferiore al valore limite di {value}{unit}",
  "alerts.conditions": "Condizioni",
  "alerts.createAlert": "Crea avviso",
  "alerts.dailyPrecipitationGreaterThan": "Precipitazione giornaliera superiore a",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Precipitazione giornaliera superiore alla soglia di {value}{unit}",
  "alerts.deleteAlert": "Elimina avviso",
  "alerts.editAlert": "Modifica avviso",
  "alerts.editCondition": "Modifica condizione",
  "alerts.gustSpeedGreaterThan": "Raffica maggiore di",
  "alerts.gustSpeedGreaterThanThreshold": "Raffica superiore al valore limite di {value}{unit}",
  "alerts.gustSpeedLessThan": "Raffica minore di",
  "alerts.gustSpeedLessThanThreshold": "Raffica inferiore al valore limite di {value}{unit}",
  "alerts.heatIndexGreaterThan": "Indice di calore maggiore di",
  "alerts.heatIndexGreaterThanThreshold": "Indice di calore superiore al valore limite di {value}{unit}",
  "alerts.heatIndexLessThan": "Indice di calore minore di",
  "alerts.heatIndexLessThanThreshold": "Indice di calore inferiore al valore limite di {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex maggiore di",
  "alerts.humidexGreaterThanThreshold": "Humidex superiore al valore limite di {value}{unit}",
  "alerts.humidexLessThan": "Humidex minore di",
  "alerts.humidexLessThanThreshold": "Humidex inferiore al valore limite di {value}{unit}",
  "alerts.humidityGreaterThan": "Umidità maggiore del",
  "alerts.humidityGreaterThanThreshold": "Umidità superiore al valore limite di {value}{unit}",
  "alerts.humidityLessThan": "Umidità minore del",
  "alerts.humidityLessThanThreshold": "Umidità inferiore al valore limite di {value}{unit}",
  "alerts.inProgress": "In corso",
  "alerts.myAlerts": "I miei avvisi",
  "alerts.noConfiguredAlert": "Non hai ancora un avviso, aggiungine uno",
  "alerts.noiseGreaterThan": "Rumore maggiore di",
  "alerts.noiseGreaterThanThreshold": "Rumore superiore al valore limite di {value}{unit}",
  "alerts.noiseLessThan": "Rumore minore di",
  "alerts.noiseLessThanThreshold": "Rumore inferiore al valore limite di {value}{unit}",
  "alerts.noteOnConditions": "Tieni presente che l'avviso viene attivato quando tutte le condizioni aggiunte sono vere",
  "alerts.noTriggerHistory": "Questo avviso non è ancora stato attivato.",
  "alerts.pm10GreaterThan": "PM 10 maggiore di",
  "alerts.pm10GreaterThanThreshold": "PM 10 superiore al valore limite di {value}{unit}",
  "alerts.pm10LessThan": "PM 10 minore di",
  "alerts.pm10LessThanThreshold": "PM 10 inferiore al valore limite di {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 maggiore di",
  "alerts.pm1GreaterThanThreshold": "PM 1 superiore al valore limite di {value}{unit}",
  "alerts.pm1LessThan": "PM 1 minore di",
  "alerts.pm1LessThanThreshold": "PM 1 inferiore al valore limite di {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 maggiore di",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 superiore al valore limite di {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 minore di",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 inferiore al valore limite di {value}{unit}",
  "alerts.postStormSummary": "Riepilogo del temporale",
  "alerts.postStormSynopsisHelper": "Riceverai una notifica di riepilogo al termine di ogni temporale.",
  "alerts.postStormSynopsisSoleCondition": "Un riepilogo post-tempesta non può essere combinato con altre condizioni.",
  "alerts.precipitationGreaterThan": "Precipitazione oraria superiore a",
  "alerts.precipitationGreaterThanThreshold": "Precipitazione oraria superiore alla soglia di {value}{unit}",
  "alerts.pressureGreaterThan": "Pressione maggiore di",
  "alerts.pressureGreaterThanThreshold": "Pressione superiore al valore limite di {value}{unit}",
  "alerts.pressureLessThan": "Pressione minore di",
  "alerts.pressureLessThanThreshold": "Pressione inferiore al valore limite di {value}{unit}",
  "alerts.rainRateGreaterThan": "Intensità di pioggia superiore a",
  "alerts.rainRateGreaterThanThreshold": "Intensità di pioggia superiore alla soglia di {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Radiazione solare maggiore di",
  "alerts.solarRadiationGreaterThanThreshold": "Radiazione solare superiore al valore limite di {value}{unit}",
  "alerts.solarRadiationLessThan": "Radiazione solare minore di",
  "alerts.solarRadiationLessThanThreshold": "Radiazione solare inferiore al valore limite di {value}{unit}",
  "alerts.stormChartUnavailable": "Lo storico della pioggia per questo temporale non è disponibile.",
  "alerts.stormDetail": "Riepilogo del temporale",
  "alerts.stormDuration": "Durata",
  "alerts.stormEnd": "Fine",
  "alerts.stormPeakRate": "Intensità massima di pioggia",
  "alerts.stormStart": "Inizio",
  "alerts.stormTotal": "Pioggia totale",
  "alerts.temperatureGreaterThan": "Temperatura maggiore di",
  "alerts.temperatureGreaterThanThreshold": "Temperatura superiore al valore limite di {value}{unit}",
  "alerts.temperatureLessThan": "Temperatura minore di",
  "alerts.temperatureLessThanThreshold": "Temperatura inferiore al valore limite di {value}{unit}",
  "alerts.thswGreaterThan": "THSW maggiore di",
  "alerts.thswGreaterThanThreshold": "THSW superiore al valore limite di {value}{unit}",
  "alerts.thswLessThan": "THSW minore di",
  "alerts.thswLessThanThreshold": "THSW inferiore al valore limite di {value}{unit}",
  "alerts.thwGreaterThan": "THW maggiore di",
  "alerts.thwGreaterThanThreshold": "THW superiore al valore limite di {value}{unit}",
  "alerts.thwLessThan": "THW minore di",
  "alerts.thwLessThanThreshold": "THW inferiore al valore limite di {value}{unit}",
  "alerts.triggerHistory": "Cronologia dell'avviso",
  "alerts.uvGreaterThan": "UV maggiore di",
  "alerts.uvGreaterThanThreshold": "UV superiore al valore limite di {value}{unit}",
  "alerts.uvLessThan": "UV minore di",
  "alerts.uvLessThanThreshold": "UV inferiore al valore limite di {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Visibilità superiore al valore limite di {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Visibilità inferiore al valore limite di {value}{unit}",
  "alerts.visiblityGreaterThan": "Visibilità maggiore di",
  "alerts.visiblityLessThan": "Visibilità minore di",
  "alerts.whichMeasure": "Per quale misurazione vuoi essere avvisato?",
  "alerts.whichModule": "Per quale modulo vorresti essere avvisato?",
  "alerts.windChillGreaterThan": "Raffreddamento da vento maggiore di",
  "alerts.windChillGreaterThanThreshold": "Raffreddamento da vento superiore al valore limite di {value}{unit}",
  "alerts.windChillLessThan": "Raffreddamento da vento minore di",
  "alerts.windChillLessThanThreshold": "Raffreddamento da vento inferiore al valore limite di {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vento maggiore di",
  "alerts.windSpeedGreaterThanThreshold": "Vento superiore al valore limite di {value}{unit}",
  "alerts.windSpeedLessThan": "Vento minore di",
  "alerts.windSpeedLessThanThreshold": "Vento inferiore al valore limite di {value}{unit}",
  "astral.astronomicalSunPhase": "{sunPhase} astronomico",
  "astral.civilSunPhase": "{sunPhase} civile",
  "astral.dawn": "Alba",
  "astral.dusk": "Crepuscolo",
  "astral.firstQuarter": "Primo quarto di luna",
  "astral.fullMoon": "Luna piena",
  "astral.lastQuarter": "Ultimo quarto di luna",
  "astral.moon": "Luna",
  "astral.moonPhases": "Fase lunare",
  "astral.moonrise": "Sorgere di luna",
  "astral.moonset": "Calare di luna",
  "astral.nauticalSunPhase": "{sunPhase} nautico",
  "astral.newMoon": "Luna nuova",
  "astral.noon": "Mezzogiorno",
  "astral.remainingDaylight": "Luce diurna rimanente",
  "astral.sunrise": "Levata del sole",
  "astral.sunriseAndSunset": "Levata del sole e tramonto",
  "astral.sunriseAt": "Alba alle {time}",
  "astral.sunset": "Tramonto",
  "astral.sunsetAt": "Tramonto alle {time}",
  "astral.totalDaylight": "Luce diurna totale",
  "astral.waningCrescent": "Luna calante",
  "astral.waningGibbous": "Gibbosità calante",
  "astral.waxingCrescent": "Luna crescente",
  "astral.waxingGibbous": "Gibbosità crescente",
  "auth.alreadyHaveAccount": "Hai già un account?",
  "auth.authContainerTagline": "La tua dashboard meteo personale. Collega le tue stazioni e ottieni dati in tempo reale a portata di mano.",
  "auth.backToLogin": "Torna al login",
  "auth.catchPhrase": "La piattaforma meteo intelligente",
  "auth.checkYourEmail": "Controlla la tua email",
  "auth.continueWithApple": "Continua con Apple",
  "auth.continueWithFacebook": "Continua con Facebook",
  "auth.continueWithGoogle": "Continua con Google",
  "auth.email": "Indirizzo email",
  "auth.emailRequiredLoginFacebook": "Per accedere con Facebook è necessario fornire l'autorizzazione tramite Email",
  "auth.emailVerification": "Verifica email",
  "auth.emailVerificationFailure": "Si è verificato un problema con la verifica dell'email.",
  "auth.emailVerificationSuccess": "La tua email è stata verificata con successo.",
  "auth.firstName": "Nome",
  "auth.forgotPassword": "Password dimenticata",
  "auth.forgotPasswordSubtitle": "Inserisci la tua email e ti invieremo un link per reimpostare la password.",
  "auth.lastName": "Cognome",
  "auth.login": "Accedi",
  "auth.loginSubtitle": "Bentornato! Inserisci i tuoi dati.",
  "auth.loginToSmartMixinDescription": "Inserisci le tue credenziali SmartMixin per accedere al tuo account.",
  "auth.logout": "Esci",
  "auth.logoutConfirmation": "Sei sicuro di volerti disconnettere?",
  "auth.noAccountYet": "Non hai ancora un account?",
  "auth.or": "o",
  "auth.password": "Password",
  "auth.passwordAgain": "Ripeti password",
  "auth.passwordReset": "Reset password",
  "auth.passwordResetSuccess": "La tua password è stata aggiornata con successo.",
  "auth.register": "Registrati",
  "auth.registerDescription": "Crea un account SmartMixin gratuito per collegare le tue stazioni meteo, monitorare i dati meteorologici e accedere a potenti strumenti di analisi.",
  "auth.registerSubtitle": "Crea il tuo account per iniziare.",
  "auth.registerSuccess": "Ti sei registrato correttamente! Ti abbiamo appena inviato un link di verifica all'indirizzo {emailAddress} con ulteriori istruzioni.",
  "auth.restorePassword": "Ripristina password",
  "auth.restorePasswordSuccess": "Ti abbiamo appena inviato un link per la reimpostazione della password all'indirizzo {emailAddress} con ulteriori istruzioni.",
  "auth.sendReset": "Invia istruzioni di ripristino",
  "auth.socialAccount": "o usa il tuo account",
  "auth.welcome": "Benvenuto in SmartMixin",
  "auth.welcomeBack": "Bentornato!",
  "calendar.april": "Aprile",
  "calendar.august": "Agosto",
  "calendar.dateFormat": "Formato data",
  "calendar.day": "Giorno",
  "calendar.december": "Dicembre",
  "calendar.end": "Fine",
  "calendar.february": "Febbraio",
  "calendar.hours": "ore",
  "calendar.hoursShort": "ore",
  "calendar.january": "Gennaio",
  "calendar.july": "Luglio",
  "calendar.june": "Giugno",
  "calendar.last24Hours": "ultime 24 ore",
  "calendar.last30Days": "ultimi 30 giorni",
  "calendar.last7Days": "ultimi 7 giorni",
  "calendar.march": "Marzo",
  "calendar.max": "Max",
  "calendar.may": "Maggio",
  "calendar.month": "Mese",
  "calendar.months": "mesi",
  "calendar.november": "Novembre",
  "calendar.october": "Ottobre",
  "calendar.oneDay": "1 giorno",
  "calendar.oneHour": "1 ora",
  "calendar.oneMonth": "1 mese",
  "calendar.oneWeek": "1 settimana",
  "calendar.previous24Hours": "Le 24 ore precedenti",
  "calendar.previous30Days": "I 30 giorni precedenti",
  "calendar.previous7Days": "I 7 giorni precedenti",
  "calendar.previousDay": "Giorno precedente",
  "calendar.previousMonth": "Il mese scorso",
  "calendar.previousWeek": "La settimana precedente",
  "calendar.previousYear": "L'anno scorso",
  "calendar.sameDayLastYear": "Lo stesso giorno dell'anno scorso",
  "calendar.sameMonthLastYear": "Lo stesso mese dell'anno scorso",
  "calendar.selectADate": "Seleziona una data",
  "calendar.selectAggregation": "Seleziona il valore visualizzato",
  "calendar.selectAMonth": "Seleziona un mese",
  "calendar.selectAYear": "Seleziona un anno",
  "calendar.selectGranularity": "Livello di dettaglio",
  "calendar.selectTimescale": "Scala temporale",
  "calendar.september": "Settembre",
  "calendar.sixHours": "6 ore",
  "calendar.start": "Inizio",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 ore",
  "calendar.use24HourFormat": "Usa il formato 24h",
  "calendar.week": "Settimana",
  "calendar.year": "Anno",
  "calendar.yesterday": "Ieri",
  "common.accountDeleted": "Il tuo account è stato cancellato con successo.",
  "common.accountOnHold": "La connessione del tuo account è scaduta. Riconnettiti per riprendere gli aggiornamenti dei dati.",
  "common.add": "Aggiungi",
  "common.addAStation": "Aggiungi stazione",
  "common.addToFavorites": "Aggiungi ai preferiti",
  "common.addYourOwnStation": "Aggiungi la tua stazione",
  "common.alreadyPremium": "Hai già un account premium!",
  "common.alsoAvailableOn": "Disponibile anche su:",
  "common.altitude": "Altitudine",
  "common.analysis": "Analisi",
  "common.aroundMe": "Attorno a me",
  "common.articleCount": "{count, plural, one {# articolo} other {# articoli}}",
  "common.articleNotFound": "Articolo non trovato",
  "common.articleNotFoundDescription": "L'articolo che stai cercando non esiste.",
  "common.average": "Media",
  "common.averageOverThePeriod": "Media nel periodo",
  "common.away": "Fuori casa",
  "common.back": "Indietro",
  "common.backToHelpCenter": "Torna al centro assistenza",
  "common.backToHome": "Torna alla Home",
  "common.bad": "Cattivo",
  "common.batteryLevel": "Livello batteria",
  "common.bestValue": "Miglior Valore",
  "common.billingDetailsAndroid": "Per l'offerta di prova gratuita, non ti verrà addebitato alcun importo se annulli 24 ore prima della scadenza del periodo gratuito. Al termine del periodo di prova puoi annullare l'abbonamento a SmartMixin in qualsiasi momento tramite le impostazioni del tuo account Google Play oppure si rinnoverà automaticamente. Questo deve essere fatto 24 ore prima della fine del periodo di abbonamento per evitare che venga addebitata un'altra tariffa mostrata nel pulsante sopra. I pagamenti dell'abbonamento verranno addebitati sul tuo account Google Play alla conferma dell'acquisto e all'inizio di ogni periodo di rinnovo.",
  "common.billingDetailsIos": "Per l'offerta di prova gratuita, non ti verrà addebitato alcun importo se annulli 24 ore prima della scadenza del periodo gratuito. Al termine del periodo di prova puoi annullare l'abbonamento a SmartMixin in qualsiasi momento tramite le impostazioni del tuo account App Store oppure si rinnoverà automaticamente. Questo deve essere fatto 24 ore prima della fine del periodo di abbonamento per evitare che venga addebitata un'altra tariffa mostrata nel pulsante sopra. I pagamenti dell'abbonamento verranno addebitati sul tuo account App Store alla conferma dell'acquisto e all'inizio di ogni periodo di rinnovo.",
  "common.boilerOn": "Caldaia ON",
  "common.browseByCategory": "Sfoglia per categoria",
  "common.calendarView": "Visualizzazione calendario",
  "common.cancel": "Annulla",
  "common.cannotBeEmpty": "Questo campo non può essere vuoto.",
  "common.cardDetails": "Estremi della carta",
  "common.categoryNotFound": "Categoria non trovata",
  "common.categoryNotFoundDescription": "Questa categoria non esiste o non contiene articoli.",
  "common.charts": "Grafici",
  "common.chartView": "Visualizzazione grafico",
  "common.clearRecentLocations": "Cancella tutto",
  "common.close": "Chiudi",
  "common.comparison": "Confronto",
  "common.contactMe": "Contattami",
  "common.currentDay": "Oggi",
  "common.currentLocation": "Posizione corrente",
  "common.currentObservations": "Osservazioni attuali",
  "common.currentRainEvent": "Evento di pioggia in corso",
  "common.currentRate": "Intensità della pioggia",
  "common.currentWeatherConditions": "Condizioni attuali",
  "common.customizeComparisonMetrics": "Personalizza le metriche di confronto",
  "common.customizeComparisonMetricsDescription": "Trascina gli elementi per riordinare le tue metriche di confronto. Tocca l'icona dell'occhio per mostrare o nascondere le metriche.",
  "common.customizeDashboard": "Personalizza",
  "common.customizeDashboardDescription": "Trascina gli elementi per riordinare la tua dashboard. Tocca l'icona dell'occhio per mostrare o nascondere le sezioni.",
  "common.customizedStationName": "Nome personalizzato della stazione",
  "common.dailyForecast": "Previsioni giornaliere",
  "common.dashboard": "Home",
  "common.default": "Predefinito",
  "common.defaultForecastModelChip": "Predefinito · {name}",
  "common.delete": "Elimina",
  "common.deleteAccount": "Elimina l'account",
  "common.deleteAccountConfirmation": "Sei sicuro di voler cancellare l'account? Questa azione è irreversibile.",
  "common.deleteAccountDescription": "Questa azione elimina il tuo account e tutte le tue informazioni. Non si può tornare indietro.",
  "common.details": "Dettagli",
  "common.edit": "Modifica",
  "common.editor": "Editor",
  "common.endTime": "Fine",
  "common.exitFullscreen": "Esci da schermo intero",
  "common.exploreWeatherMap": "Esplora la Mappa Meteo",
  "common.favoriteLocations": "Preferiti",
  "common.favoriteLocationsEmpty": "Puoi aggiungere fino a 5 posizioni preferite.",
  "common.favoriteStations": "Stazioni preferite",
  "common.feedbackHelpsImprove": "I tuoi commenti ci aiutano a migliorare i nostri articoli di assistenza.",
  "common.feedbackReasonNotAnswer": "Non risponde alla mia domanda",
  "common.feedbackReasonOutdated": "Le informazioni non sono aggiornate",
  "common.feedbackReasonUnclear": "Le istruzioni non sono chiare",
  "common.feedbackWhatWentWrong": "Qual è stato il problema?",
  "common.filterStationDescription": "Non visualizzare stazioni con misure inaffidabili",
  "common.filterStations": "Filtra stazioni",
  "common.filterStationSourceDescription": "Seleziona i fornitori di stazioni che desideri visualizzare sulla mappa",
  "common.findStationsNearYou": "Trova stazioni vicino a te",
  "common.firmwareVersion": "Versione firmware",
  "common.forecast": "Previsione",
  "common.forecastComparisonDescription": "Confronta facilmente i dati di previsione da diverse fonti meteo",
  "common.forecastModelComparison": "Confronto dei modelli meteo",
  "common.forecastModelCoverage": "Copertura",
  "common.forecastModelDescription": "Descrizione",
  "common.forecastModelDescription_AROME": "Modello ad alta risoluzione di Météo France con risoluzione della convezione sull’Europa occidentale a 1,3 km. Il migliore della categoria per le previsioni a breve termine in Francia; aggiornato ogni tre ore.",
  "common.forecastModelDescription_ARPEGE_EU": "Il nido europeo del modello ARPEGE di Météo France con risoluzione di 10 km. Previsioni a medio termine sull’Europa, aggiornate quattro volte al giorno.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Modello globale di previsione numerica del tempo di Météo France con risoluzione di 25 km, fino a circa 4 giorni. Aggiornato quattro volte al giorno.",
  "common.forecastModelDescription_DMI_DINI": "HARMONIE DINI di DMI: modello a convezione esplicita sull'Europa nord-occidentale — Danimarca, Benelux, Irlanda, Regno Unito e Scandinavia — con risoluzione di 2 km fino a 60 ore, aggiornato otto volte al giorno. Contiene dati aperti DMI modificati (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Sistema Globale Deterministico di Previsione di Environment Canada: modello mondiale a medio termine con risoluzione di 15 km fino a 10 giorni, aggiornato due volte al giorno.",
  "common.forecastModelDescription_EC_HRDPS": "Sistema Deterministico di Previsione ad Alta Risoluzione di Environment Canada: modello a convezione esplicita sul Canada e sul nord degli Stati Uniti con risoluzione di 2,5 km fino a 48 ore, aggiornato quattro volte al giorno.",
  "common.forecastModelDescription_EC_RDPS": "Sistema Regionale Deterministico di Previsione di Environment Canada: modello a medio termine sul Nord America con risoluzione di 10 km, aggiornato quattro volte al giorno.",
  "common.forecastModelDescription_ECMWF_HRES": "Il modello di punta ad alta risoluzione (IFS) del Centro europeo per le previsioni meteorologiche a medio termine, ampiamente considerato il miglior sistema di previsione globale al mondo. Copre l'intero pianeta con una risoluzione di 25 km fino a 15 giorni, aggiornato quattro volte al giorno. Contiene dati aperti ECMWF modificati (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "Il modello globale di punta a medio termine della NOAA. Copre l’intero pianeta con risoluzione di 25 km fino a 16 giorni, aggiornato quattro volte al giorno.",
  "common.forecastModelDescription_HRRR_CONUS": "Il High-Resolution Rapid Refresh della NOAA: modello con risoluzione della convezione sugli Stati Uniti continentali a 3 km, aggiornato ogni ora. Il più adatto per previsioni a brevissimo termine di temporali e maltempo.",
  "common.forecastModelDescription_ICON": "Il modello globale ICON del DWD con risoluzione di 13 km che copre l'intero pianeta fino a 7,5 giorni, aggiornato quattro volte al giorno. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ICON-2I di ItaliaMeteo, gestito insieme ad ARPAE: modello a convezione esplicita sull'Italia con risoluzione di 2,2 km fino a 72 ore, aggiornato due volte al giorno. Contiene dati aperti ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "Il run di controllo ICON-CH1-EPS di MeteoSwiss: modello a convezione esplicita sulle Alpi con risoluzione di 1 km fino a 33 ore, aggiornato ogni tre ore.",
  "common.forecastModelDescription_ICON_CH2": "Il run di controllo ICON-CH2-EPS di MeteoSwiss: modello a convezione esplicita sulle Alpi — Svizzera e regione alpina circostante — con risoluzione di 2,1 km fino a 120 ore, aggiornato quattro volte al giorno.",
  "common.forecastModelDescription_ICON_DE": "Modello ad alta risoluzione di DWD con risoluzione della convezione sulla Germania e i Paesi limitrofi a 2,2 km. Previsioni a breve termine aggiornate due volte al giorno. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "Il nido europeo del modello ICON di DWD con risoluzione di 7 km che copre Europa e Nord Atlantico. Previsioni a medio termine aggiornate quattro volte al giorno. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Il servizio di previsioni meteorologiche aperto dell’Istituto Meteorologico Norvegese, che combina modelli nordici ad alta risoluzione con i dati ECMWF per fornire previsioni mondiali fino a 10 giorni in anticipo.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Nido AROME sulle Antille francesi (Guadalupa, Martinica) con risoluzione di 2,5 km. Previsioni a breve termine aggiornate quattro volte al giorno.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Nido AROME sulla Guyana francese con risoluzione di 2,5 km. Previsioni a breve termine aggiornate quattro volte al giorno.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Nido AROME sulla Nuova Caledonia con risoluzione di 2,5 km. Previsioni a breve termine aggiornate quattro volte al giorno.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Nido AROME sulla Polinesia francese con risoluzione di 2,5 km. Previsioni a breve termine aggiornate quattro volte al giorno.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Nido AROME su Riunione e Mayotte con risoluzione di 2,5 km. Previsioni a breve termine aggiornate quattro volte al giorno.",
  "common.forecastModelDescription_NAM_CONUS": "Nido del modello North American Mesoscale della NOAA sugli Stati Uniti continentali con risoluzione di 5 km. Previsioni a breve termine aggiornate quattro volte al giorno.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Il modello North American Mesoscale della NOAA che copre tutto il Nord America con risoluzione di 32 km. Aggiornato quattro volte al giorno.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "Previsione di punta di SmartMixin. Per ogni ora nella tua posizione, scegliamo il miglior modello disponibile — in genere un modello regionale ad alta risoluzione dove ce n’è uno (AROME in Francia, ICON-D2 in Germania, HRRR negli Stati Uniti, ARPEGE Europe in tutto il continente…) e altrove ripieghiamo su un modello globale — quindi colmiamo eventuali lacune con fonti vicine. Il risultato è una singola previsione fluida che copre qualsiasi punto del mondo fino a 14 giorni, aggiornata automaticamente ogni volta che uno dei modelli sottostanti viene aggiornato.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Previsione globale proprietaria di Weatherflow che combina più modelli numerici di previsione con osservazioni dalla sua rete di stazioni meteorologiche Tempest. Orizzonte mondiale di 10 giorni.",
  "common.forecastModelDetailTitle": "Modello di previsione",
  "common.forecastModelScopeGlobal": "Globale",
  "common.forecastModelScopeGlobalDescription": "Questo modello copre l’intero pianeta.",
  "common.forecastModelScopeRegional": "Regionale",
  "common.forecastModelScopeRegionalDescription": "Questo modello copre solo una regione specifica.",
  "common.forecastModelSpecifications": "Specifiche",
  "common.forecastSources": "Fonti meteo",
  "common.freeAccount": "Account gratuito",
  "common.freeSubscription": "Abbonamento premium gratuito",
  "common.freeTrialForPeriod": "Prova gratuita per {period} giorni",
  "common.frequency": "Frequenza",
  "common.full": "Completo",
  "common.fullscreen": "Schermo intero",
  "common.getStartedFree": "Inizia Gratis",
  "common.getUnlimitedAccess": "Accesso illimitato a:",
  "common.good": "Buono",
  "common.hail": "Grandine",
  "common.help": "Aiuto",
  "common.helpCategoryAccount": "Account",
  "common.helpCategoryBilling": "Fatturazione",
  "common.helpCategoryGettingStarted": "Per iniziare",
  "common.helpCategoryProviders": "Fornitori",
  "common.helpCategoryStations": "Stazioni",
  "common.helpCategoryTroubleshooting": "Risoluzione problemi",
  "common.helpCenter": "Centro assistenza",
  "common.helpCenterDescription": "Trova risposte alle domande più comuni e scopri come ottenere il massimo da SmartMixin.",
  "common.hg": "Protezione antigelo",
  "common.hidden": "Nascosti",
  "common.hiddenSensors": "Sensori nascosti",
  "common.hiddenStations": "Stazioni nascoste",
  "common.hiddenStationsDescription": "Puoi mostrare di nuovo una stazione toccando l'icona dell'occhio accanto ad essa.",
  "common.high": "Alto",
  "common.home": "Casa",
  "common.homeConnectService": "Possiedi una stazione meteo? Collega il tuo servizio",
  "common.homeInformation": "Informazioni sulla casa",
  "common.homeIntroduction": "Inizia a connettere i tuoi account esterni per usufruire delle funzionalità di SmartMixin.",
  "common.homeName": "Nome casa",
  "common.homeSubtitle": "Il tuo meteo, tutto in un unico posto",
  "common.horizon": "Orizzonte",
  "common.horizonValue": "fino a {value} ore",
  "common.iDontKnowYet": "Non lo so ancora",
  "common.indoor": "Interno",
  "common.lastRainEvent": "Ultimo evento di pioggia",
  "common.lastUpdate": "Ultimo aggiornamento",
  "common.legendHeavy": "Forte",
  "common.legendLight": "Leggera",
  "common.legendLightningHelp": "Il colore indica l'età di ogni fulmine negli ultimi {minutes} minuti — i più recenti in bianco, i più vecchi in rosso scuro.",
  "common.legendNewest": "Più recenti",
  "common.legendOldest": "Più vecchi",
  "common.legendStationsHelp": "Il colore del marcatore riflette il valore della metrica selezionata.",
  "common.lightningDataAttribution": "Dati sui fulmini: Blitzortung.org",
  "common.lightningStrikes": "Fulmini",
  "common.lightningStrikesDescription": "Mostra i fulmini in tempo reale sulla mappa",
  "common.linkToSection": "Link a questa sezione",
  "common.loading": "Caricamento",
  "common.location": "Località",
  "common.locationAddedToFavorites": "Posizione aggiunta ai preferiti",
  "common.locationNotGranted": "L'autorizzazione alla posizione non è concessa. Si prega di consentire l'accesso alla posizione nelle impostazioni del dispositivo.",
  "common.locationRemovedFromFavorites": "Posizione rimossa dai preferiti",
  "common.locations": "Località",
  "common.low": "Basso",
  "common.manage": "Gestisci",
  "common.manageAccount": "Gestisci account",
  "common.manageMySubscription": "Gestisci il mio abbonamento",
  "common.manageSensors": "Gestisci sensori",
  "common.manageSensorsDescription": "Trascina gli elementi per riordinare i sensori. Tocca l'icona dell'occhio per mostrare o nascondere i sensori. Tocca un nome per rinominarlo.",
  "common.manualBoost": "Incremento manuale",
  "common.manualSetpointUntil": "Impostazione manuale fino a",
  "common.mapLayers": "Livelli della mappa",
  "common.mapLegend": "Legenda della mappa",
  "common.maxFavoriteLocationsReached": "Puoi avere solo fino a 5 luoghi preferiti. Rimuovi uno per aggiungerne un altro.",
  "common.maximum": "Massimo",
  "common.measureToDisplay": "Misura da visualizzare",
  "common.medium": "Medio",
  "common.meshSize": "Dimensione griglia",
  "common.minimum": "Minimo",
  "common.minRead": "{minutes} min di lettura",
  "common.modifyFavoriteStations": "Modifica le stazioni preferite",
  "common.modifyFavoriteStationsDescription": "Puoi riordinare le tue stazioni preferite trascinandole. Puoi anche rimuoverli dall'elenco.",
  "common.moduleType": "Tipo di modulo",
  "common.monthTotal": "Totale mensile",
  "common.more": "Altro",
  "common.moreInformation": "Più informazioni",
  "common.myLocation": "La mia posizione",
  "common.nearbyWeatherStations": "Stazioni meteorologiche vicine",
  "common.next": "Prossimo",
  "common.nextHours": "Prossime ore",
  "common.no": "No",
  "common.noAccountNeeded": "Nessun account necessario",
  "common.noDataForThisPeriod": "Nessun dato nel periodo",
  "common.noLocationsFound": "Nessuna località trovata",
  "common.noNetatmoWeatherStationYet": "Non possiedi ancora una stazione meteo",
  "common.noOutdoorModule": "Nessun modulo esterno funzionante per questa stazione.",
  "common.noSearchResults": "Nessun articolo corrisponde alla ricerca",
  "common.noStationsFound": "Nessuna stazione trovata",
  "common.noThermostatYet": "Non possiedi ancora un termostato",
  "common.notNow": "Non ora",
  "common.notPurchasedYet": "Sembra che tu non abbia acquistato nulla ancora...",
  "common.noWeatherStation": "Nessuna stazione meteo",
  "common.noWeatherStationYet": "Non possiedi ancora una stazione meteo",
  "common.numberOfActiveWarnings": "{warning_count} avvisi meteorologici attivi",
  "common.onThisPage": "In questa pagina",
  "common.openSettings": "Apri impostazioni",
  "common.orChooseMonthly": "Oppure scegli mensile:",
  "common.outdatedModule": "I dati per questo modulo non sono aggiornati.",
  "common.outdoor": "Esterno",
  "common.outdoorTemperature": "Temperatura esterna",
  "common.pageNotFound": "Pagina Non Trovata",
  "common.pageNotFoundDescription": "La pagina che stai cercando non esiste o è stata spostata.",
  "common.passwordUpdated": "Password aggiornata con successo.",
  "common.personalWeatherIntelligence": "La Tua Intelligenza Meteo Personale",
  "common.platformMobileApp": "App mobile",
  "common.platformMobileOnly": "Solo nell'app mobile",
  "common.platformWebApp": "App web",
  "common.platformWebOnly": "Solo nell'app web",
  "common.popularArticles": "Articoli più letti",
  "common.premiumAccount": "Account premium",
  "common.premiumDescription": "L'abbonamento Premium sblocca una vasta gamma di funzionalità aggiuntive come analisi meteorologiche avanzate, confronto di grafici, modelli di previsioni regionali e molto altro ancora.",
  "common.premiumFeatureAlerts": "Allerte Meteo",
  "common.premiumFeatureAnalysis": "Analisi Meteo Avanzata",
  "common.premiumFeatureCharts": "Confronti Grafici",
  "common.premiumFeatureExport": "Esportazione Dati",
  "common.premiumFeatureForecast": "Modelli di Previsione Regionali",
  "common.premiumFeatureNotification": "Widget Barra di Stato",
  "common.premiumFeatureTitle": "Funzione Premium",
  "common.premiumFeatureWidgets": "Widget schermata principale",
  "common.pressureSummary": "Sintesi della pressione",
  "common.previous": "Precedente",
  "common.previousHours": "Ore precedenti",
  "common.profileUpdated": "Profilo aggiornato correttamente.",
  "common.purchasedNetatmoPro": "Hai già acquistato Netatmo Pro ({date}). Questo ti dà accesso a un sottoinsieme di funzionalità premium. Iscriviti a una delle seguenti offerte se desideri avere accesso a tutte le funzionalità premium.",
  "common.radarDataAttribution": "Dati radar: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Pioggia",
  "common.rainEvents": "Eventi di pioggia",
  "common.rainfallMeasurement": "Misurazione delle precipitazioni",
  "common.rainRadar": "Radar pioggia",
  "common.rainRadarDescription": "Visualizza la sovrapposizione del radar pioggia sulla mappa",
  "common.rainSummary": "Riepilogo pioggia",
  "common.range": "Intervallo",
  "common.recentLocations": "Recente",
  "common.recentLocationsEmpty": "La tua storia recente è vuota.",
  "common.recentStations": "Stazioni recenti",
  "common.relatedArticles": "Articoli correlati",
  "common.relay": "Relè",
  "common.removeFromFavorites": "Rimuovi dai preferiti",
  "common.renameSensors": "Rinomina i sensori",
  "common.resetZoom": "Reimposta zoom",
  "common.restorePurchase": "Ripristina acquisto",
  "common.room": "Stanza",
  "common.rooms": "Stanze",
  "common.savingsPercent": "Risparmia {percent}%",
  "common.searchArticles": "Cerca articoli...",
  "common.searchForALocation": "Cerca una posizione...",
  "common.searchForLocation": "Cerca una località",
  "common.searchForWeatherStation": "Cerca una stazione meteo",
  "common.searchResults": "Risultati di ricerca",
  "common.searchResultsEmpty": "Nessun risultato trovato.",
  "common.searchResultsFound": "{count, plural, one {# risultato trovato} other {# risultati trovati}}",
  "common.searchStationsDescription": "Inserisci una città, un indirizzo o un nome di luogo per trovare stazioni meteo nelle vicinanze.",
  "common.searchStationsHint": "Usa la barra di ricerca sopra per scoprire stazioni meteo in qualsiasi luogo del mondo.",
  "common.selectStationForComparison": "Seleziona una stazione per il confronto",
  "common.selectWeatherForecastProvider": "Scegli un fornitore di servizi meteo",
  "common.serialNumber": "Numero di serie",
  "common.share": "Condividi",
  "common.shareOutdoorMeasures": "Condividi le tue misure esterne",
  "common.shareOutdoorMeasuresDescription": "Partecipa alla community SmartMixin rendendo visibili agli altri le tue misure esterne. Le misure interne non saranno mai condivise.",
  "common.shareYourWeather": "Condividi il tuo meteo",
  "common.signalStrength": "Potenza del segnale",
  "common.skip": "Saltare",
  "common.smartThermostat": "Termostato intelligente",
  "common.smartValve": "Valvola intelligente",
  "common.snow": "Neve",
  "common.start": "Inizio",
  "common.startFreeTrial": "Inizia Prova Gratuita",
  "common.startTime": "Inizio",
  "common.station": "stazione",
  "common.stationAddedToFavorites": "Stazione aggiunta ai preferiti",
  "common.stationComparison": "Confronto tra stazioni",
  "common.stationComparisonDescription": "Confronta i dati meteorologici storici con un'altra stazione",
  "common.stationInformation": "Informazioni sulla stazione",
  "common.stationName": "Nome stazione",
  "common.stationObservationsDescription": "Visualizza le ultime osservazioni delle stazioni meteorologiche",
  "common.stationRemovedFromFavorites": "Stazione rimossa dai preferiti",
  "common.stations": "stazioni",
  "common.stationsNear": "Stazioni vicino a",
  "common.stationType": "Tipo di stazione",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Obsoleto",
  "common.statusSyncing": "Sincronizzazione",
  "common.stillNeedHelp": "Ha ancora bisogno di aiuto?",
  "common.stillNeedHelpDescription": "Se questo articolo non ha risposto alla Sua domanda, sarò lieto di aiutarLa direttamente.",
  "common.subscribeNow": "Abbonati ora - senza prova",
  "common.sumOverThePeriod": "Cumulato nel periodo",
  "common.switchToPremium": "Passa a SmartMixin Premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Riepilogo temperatura",
  "common.thankYouForFeedback": "Grazie per il tuo feedback!",
  "common.thenPrice": "poi {price}",
  "common.timeSelection": "Selezione dell'ora",
  "common.timezone": "Fuso orario",
  "common.totalDuration": "Durata totale",
  "common.tryAnotherLocation": "Non abbiamo trovato stazioni meteo vicino a questa posizione. Prova a cercare in un'altra zona.",
  "common.unknown": "Sconosciuto",
  "common.untilChanged": "Fino al cambiamento",
  "common.untilTime": "Fino a {time}",
  "common.updateAvailable": "Aggiornamento disponibile",
  "common.updateAvailableOpenAppStore": "Tocca per aprire l'App Store",
  "common.updateAvailableOpenGooglePlay": "Tocca per aprire Google Play",
  "common.updateAvailableVersion": "Aggiornamento disponibile: v{version}",
  "common.upgrade": "Upgrade",
  "common.upgradeRequiredAndroid": "È richiesto un aggiornamento della tua applicazione, vai su Google Play per eseguire l'aggiornamento.",
  "common.upgradeRequiredIos": "È richiesto un aggiornamento della tua applicazione, vai nello Store per eseguire l'aggiornamento.",
  "common.validate": "Convalida",
  "common.validEmail": "È richiesto un indirizzo email valido.",
  "common.very_low": "Molto basso",
  "common.visitNetatmoWebsite": "Visita il sito di Netatmo",
  "common.wasArticleHelpful": "Questo articolo ti è stato utile?",
  "common.weatherCondition": "Condizione meteorologica",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain è un'ulteriore fonte di dati fornita tramite il Tempest Weather System, basato sulla tecnologia Nearcast. I dati sulla NC rain sono una stima dell'accumulo medio di precipitazioni attorno al tuo Tempest a livello di quartiere",
  "common.weatherForecastModels": "Modelli di previsioni meteorologiche",
  "common.weatherIntelligencePlatform": "La Piattaforma di Intelligenza Meteo",
  "common.weatherMap": "Weathermap",
  "common.weatherMapMetaDescription": "SmartMixin offre mappe meteo interattive e radar pioggia per le condizioni meteorologiche in tutto il mondo.",
  "common.weatherObservations": "Osservazioni meteorologiche",
  "common.weatherStation": "Stazione meteorologica",
  "common.weatherStations": "Stazioni meteorologiche",
  "common.welcome": "Benvenuto in SmartMixin!",
  "common.whenBackHome": "Quando tornerai a casa?",
  "common.wifiStrength": "Potenza WiFi",
  "common.wind": "Vento",
  "common.windMeasurement": "Misurazione del vento",
  "common.windSpeed": "Velocità del vento",
  "common.windSummary": "Sintesi del vento",
  "common.yearToDate": "Da inizio anno",
  "common.yes": "Sì",
  "common.zoomImage": "Ingrandisci immagine",
  "forecastMaps.addColor": "Aggiungi colore",
  "forecastMaps.addLayer": "Aggiungi livello",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Torna alle mappe",
  "forecastMaps.browseMaps": "Sfoglia le mappe",
  "forecastMaps.build": "Genera",
  "forecastMaps.buildCompleted": "Generazione completata",
  "forecastMaps.builderMetaDescription": "Componi mappe di previsione personalizzate dai livelli dei modelli meteo.",
  "forecastMaps.builderTitle": "Editor di mappe",
  "forecastMaps.buildFailed": "La generazione non è riuscita. Riprova.",
  "forecastMaps.buildNotPossible": "Questa mappa non può ancora essere generata — nessun dato di previsione disponibile.",
  "forecastMaps.buildProgress": "Rendering… {completed}/{total} passaggi",
  "forecastMaps.buildStarting": "Avvio della generazione…",
  "forecastMaps.byModel": "Per modello",
  "forecastMaps.byZone": "Per zona",
  "forecastMaps.colormap": "Mappa colori",
  "forecastMaps.colormapCustom": "Colori personalizzati",
  "forecastMaps.colormapGroupDomain": "Preset meteo",
  "forecastMaps.colormapGroupMatplotlib": "Preset scientifici",
  "forecastMaps.colorScale": "Scala di colori",
  "forecastMaps.comingSoon": "Questa vista sarà presto disponibile.",
  "forecastMaps.contourLevels": "Livelli di contorno",
  "forecastMaps.countryCanada": "Canada",
  "forecastMaps.countryFrance": "Francia",
  "forecastMaps.countryGermany": "Germania",
  "forecastMaps.countryItaly": "Italia",
  "forecastMaps.countryScandinavia": "Scandinavia",
  "forecastMaps.countrySpain": "Spagna",
  "forecastMaps.countrySwitzerland": "Svizzera",
  "forecastMaps.countryUnitedStates": "Stati Uniti",
  "forecastMaps.customColormapMinColors": "Una mappa colori personalizzata richiede almeno due colori",
  "forecastMaps.customExtent": "Estensione personalizzata",
  "forecastMaps.deleteMap": "Elimina mappa",
  "forecastMaps.deleteMapBody": "«{name}» e i relativi rendering verranno eliminati definitivamente.",
  "forecastMaps.deleteMapTitle": "Eliminare questa mappa?",
  "forecastMaps.displayName": "Nome visualizzato",
  "forecastMaps.downloadMp4": "Scarica MP4",
  "forecastMaps.downscaling": "Fattore di diradamento delle barbe",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Disegna area",
  "forecastMaps.east": "Est",
  "forecastMaps.editMap": "Modifica mappa",
  "forecastMaps.exportBuilding": "Preparazione del video…",
  "forecastMaps.exportError": "L'esportazione del video non è riuscita. Riprova.",
  "forecastMaps.exportMp4": "Esporta MP4",
  "forecastMaps.exportNotReady": "Il video non è ancora pronto. Riprova più tardi.",
  "forecastMaps.extentDrawHint": "Trascina sulla mappa per disegnare l'area",
  "forecastMaps.extentInvalid": "L'ovest deve essere minore dell'est e il sud minore del nord",
  "forecastMaps.extentPanZoomHint": "Sposta e ingrandisci finché l'area non riempie il riquadro",
  "forecastMaps.flipbookView": "Animazione",
  "forecastMaps.forecastModel": "Modello di previsione",
  "forecastMaps.forkAndEdit": "Duplica e modifica",
  "forecastMaps.height": "Altezza (pollici)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Colore non valido — usa #RRGGBB",
  "forecastMaps.layers": "Livelli",
  "forecastMaps.layerTypeBarbs": "Barbe del vento",
  "forecastMaps.layerTypeContour": "Linee di contorno",
  "forecastMaps.layerTypeFilledContour": "Contorni pieni",
  "forecastMaps.layerTypeMagnitude": "Magnitudine",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Campo vettoriale",
  "forecastMaps.leave": "Esci",
  "forecastMaps.levelsCount": "Numero",
  "forecastMaps.levelsInvalid": "Livelli di contorno non validi",
  "forecastMaps.levelsModeArange": "Passo fisso",
  "forecastMaps.levelsModeExplicit": "Valori espliciti",
  "forecastMaps.levelsModeLinspace": "Spaziatura uniforme (numero)",
  "forecastMaps.levelsStep": "Passo",
  "forecastMaps.levelsValues": "Valori",
  "forecastMaps.levelsValuesHint": "Separati da virgole, crescenti",
  "forecastMaps.localTimeHint": "Mostrato nella tua ora locale",
  "forecastMaps.map": "Mappa",
  "forecastMaps.mapDescription": "Descrizione",
  "forecastMaps.mapName": "Nome della mappa",
  "forecastMaps.mapNameRequired": "Inserisci un nome",
  "forecastMaps.mapSettings": "Impostazioni mappa",
  "forecastMaps.mapView": "Mappa interattiva",
  "forecastMaps.maxLayersReached": "Questa mappa ha raggiunto il massimo di {max} livelli.",
  "forecastMaps.maxValue": "Valore massimo",
  "forecastMaps.memoryBudgetExceeded": "La risoluzione supera il budget di rendering — riduci i DPI o l'altezza",
  "forecastMaps.memoryBudgetUsage": "Budget di rendering: {percent}%",
  "forecastMaps.metaDescription": "Mappe di previsione animate generate dai modelli meteorologici.",
  "forecastMaps.metric": "Misura",
  "forecastMaps.metricRequired": "Seleziona una misura",
  "forecastMaps.metricUnavailable": "Non disponibile per questo modello",
  "forecastMaps.minBelowMax": "Il minimo deve essere inferiore al massimo",
  "forecastMaps.minMaxRequired": "I valori minimo e massimo sono obbligatori per questo tipo di livello",
  "forecastMaps.minValue": "Valore minimo",
  "forecastMaps.modelNoRun": "Nessuna esecuzione completata al momento",
  "forecastMaps.moveLayerDown": "Sposta giù",
  "forecastMaps.moveLayerUp": "Sposta su",
  "forecastMaps.myMaps": "Le mie mappe",
  "forecastMaps.nanClipToMin": "Limita al minimo",
  "forecastMaps.nanMask": "Maschera",
  "forecastMaps.nanPolicy": "Dati mancanti",
  "forecastMaps.nanSkip": "Ignora",
  "forecastMaps.newMap": "Nuova mappa",
  "forecastMaps.noCompletedRun": "Questa mappa non è ancora stata generata. Ricontrolla a breve.",
  "forecastMaps.noLayers": "Nessun livello. Aggiungi un livello per iniziare.",
  "forecastMaps.noMapsAvailable": "Non sono ancora disponibili mappe di previsione.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Opacità",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pausa",
  "forecastMaps.play": "Riproduci",
  "forecastMaps.pointValueError": "Impossibile caricare la previsione per questo punto.",
  "forecastMaps.pointValueLoading": "Caricamento previsione…",
  "forecastMaps.pointValueUnavailable": "Nessun dato per questo orario.",
  "forecastMaps.presets": "Preset",
  "forecastMaps.preview": "Anteprima",
  "forecastMaps.previewEmptyHint": "Configura almeno un livello valido per generare un'anteprima.",
  "forecastMaps.previewFailed": "L'anteprima non è riuscita",
  "forecastMaps.previewHour": "Ora di previsione",
  "forecastMaps.previewRendering": "Rendering dell'anteprima…",
  "forecastMaps.projection": "Proiezione",
  "forecastMaps.projectionLambertConformal": "Lambert conforme",
  "forecastMaps.projectionMercator": "Mercatore",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografica",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Nord America",
  "forecastMaps.removeColor": "Rimuovi colore",
  "forecastMaps.removeLayer": "Rimuovi livello",
  "forecastMaps.retry": "Riprova",
  "forecastMaps.run": "Run: {run}",
  "forecastMaps.save": "Salva",
  "forecastMaps.selectExtentOnMap": "Seleziona l'area sulla mappa",
  "forecastMaps.south": "Sud",
  "forecastMaps.title": "Mappe di previsione",
  "forecastMaps.uMetric": "Componente U",
  "forecastMaps.unitConversion": "Conversione di unità",
  "forecastMaps.unitNone": "Nessuna",
  "forecastMaps.unsavedChangesBody": "Hai modifiche non salvate. Uscire e scartarle?",
  "forecastMaps.unsavedChangesTitle": "Modifiche non salvate",
  "forecastMaps.useCurrentView": "Usa la vista corrente",
  "forecastMaps.useModelDomain": "Disattivato: viene usato l'intero dominio del modello",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Le misure U e V devono essere diverse",
  "forecastMaps.validTime": "Validità: {time}",
  "forecastMaps.valueBetween": "Deve essere compreso tra {min} e {max}",
  "forecastMaps.variable": "Variabile",
  "forecastMaps.viewMap": "Vedi mappa",
  "forecastMaps.vMetric": "Componente V",
  "forecastMaps.west": "Ovest",
  "forecastMaps.windAnimation": "Animazione del vento",
  "intro.locationDescription": "Attiva l'accesso alla posizione per ottenere previsioni meteo precise adattate alla tua esatta area — niente più comunicati generici.",
  "intro.locationTitle": "Previsioni create per te",
  "intro.notificationDescription": "Attiva le notifiche per ricevere avvisi tempestivi sui cambiamenti meteorologici che contano per te — pioggia, neve o condizioni severe, proprio quando serve.",
  "intro.notificationsTitle": "Non perdere nessun cambiamento meteo",
  "intro.readyDescription": "Goditi previsioni precise, informazioni meteo in tempo reale e dati dalle stazioni di tutto il mondo — tutto in un’unica potente app.",
  "intro.readyTitle": "Sei pronto!",
  "intro.welcomeDescription": "Ricevi previsioni iperlocali dalle migliori agenzie meteorologiche — più accesso a oltre 40.000 stazioni meteo in tutto il mondo per vedere le condizioni reali, passate e presenti.",
  "intro.welcomeTitle": "Il tuo meteo, reinventato",
  "landing.alerts": "Avvisi",
  "landing.alertsDescription": "Crea i tuoi avvisi e ricevi una notifica non appena vengono attivati.",
  "landing.featureAlertsDescription": "Imposta soglie personalizzate per qualsiasi metrica. Ricevi notifiche quando la temperatura scende, inizia a piovere o si alza il vento.",
  "landing.featureAlertsTitle": "Avvisi intelligenti",
  "landing.featureAnalyticsDescription": "Grafici interattivi, analisi delle tendenze e statistiche dettagliate. Approfondisci i dati di temperatura, umidità, pressione, pioggia e vento.",
  "landing.featureAnalyticsTitle": "Analisi avanzate",
  "landing.featureExportDescription": "Scarica i tuoi dati meteo come file CSV per ulteriori analisi in Excel, Google Sheets o i tuoi strumenti preferiti.",
  "landing.featureExportTitle": "Esporta i tuoi dati",
  "landing.featureForecastDescription": "Accedi a oltre 10 modelli previsionali professionali tra cui ECMWF, GFS e modelli regionali. Confrontali fianco a fianco per fare le tue previsioni.",
  "landing.featureForecastTitle": "Confronta i modelli previsionali",
  "landing.featureHistoryDescription": "Accedi ai dati storici con scala oraria, giornaliera e mensile. Esporta in CSV per ricerche o archivi personali.",
  "landing.featureHistoryTitle": "Storico completo",
  "landing.featureMultiBrandDescription": "Collega Netatmo, Davis, Tempest, Ecowitt, Ambient Weather e altro. Basta passare da un'app all'altra.",
  "landing.featureMultiBrandTitle": "Tutti i marchi, un'unica app",
  "landing.featuresSubtitle": "SmartMixin ti offre gli strumenti per analizzare, confrontare e comprendere i tuoi dati meteo come un professionista.",
  "landing.featuresTitle": "Creato per gli amanti dei dati",
  "landing.finalCtaButton": "Crea account gratuito",
  "landing.finalCtaSubtitle": "Unisciti a migliaia di appassionati di meteo che si fidano di SmartMixin.",
  "landing.finalCtaTitle": "Pronto ad approfondire i tuoi dati meteo?",
  "landing.forecastDescription": "Accedi ad alcuni dei migliori modelli di previsioni del tempo e confrontali per avere la tua idea di che tempo farà.",
  "landing.forecasts": "Previsioni",
  "landing.heroCta": "Inizia gratis",
  "landing.heroDescription": "Analisi approfondite, grafici eleganti e previsioni professionali — tutte le tue stazioni meteo riunite in un'unica potente app.",
  "landing.heroSecondaryCta": "Esplora la mappa",
  "landing.heroTagline": "Per gli appassionati di meteo",
  "landing.heroTitle": "Guarda il tuo meteo come mai prima",
  "landing.pricingFeatureAdvancedMetrics": "Metriche avanzate",
  "landing.pricingFeatureAlerts": "Avvisi personalizzati",
  "landing.pricingFeatureExport": "Esportazione dati (CSV)",
  "landing.pricingFeatureForecastComparison": "Confronto previsioni",
  "landing.pricingFeatureForecasts": "Modelli previsionali",
  "landing.pricingFeatureForecastsFreeTier": "1 modello",
  "landing.pricingFeatureForecastsPremiumTier": "10+ modelli",
  "landing.pricingFeatureReports": "Analisi e report",
  "landing.pricingFeatureStationComparison": "Confronto stazioni",
  "landing.pricingFeatureWidgets": "Widget schermata home",
  "landing.pricingFeatureYearOverYear": "Analisi anno su anno",
  "landing.pricingFree": "Gratuito",
  "landing.pricingFreeCta": "Inizia",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Più popolare",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Inizia",
  "landing.pricingPremiumDescription": "Da 1,99 €/mese — abbonati su web, App Store o Google Play",
  "landing.pricingSubtitle": "Inizia gratis, passa a Premium quando hai bisogno di più potenza.",
  "landing.pricingTitle": "Prezzi semplici e trasparenti",
  "landing.smartMixinDescription": "SmartMixin è un'applicazione che fornisce l'accesso alla tua stazione meteorologica e a oltre 40.000 altre stazioni in tutto il mondo. Ti aiuta a vedere e comprendere i dati meteorologici.",
  "landing.statBrands": "Marchi supportati",
  "landing.statForecasts": "Modelli previsionali",
  "landing.statStations": "Stazioni meteo",
  "landing.supportedDevices": "Dispositivi supportati",
  "landing.supportedDevicesDescription": "Oltre alle stazioni dell'Organizzazione Meteorologica Mondiale, SmartMixin supporta un numero crescente di marchi di stazioni meteorologiche.",
  "landing.supportedDevicesNote": "Più 40.000+ stazioni pubbliche dell'Organizzazione Meteorologica Mondiale",
  "landing.supportedDevicesSubtitle": "Collega la tua stazione meteo esistente in pochi minuti. Supportiamo 8 marchi principali e altri in arrivo.",
  "landing.supportedDevicesTitle": "Funziona con la tua stazione",
  "landing.thermostatDescription": "Collega il tuo termostato Netatmo per correlare i pattern di riscaldamento con le condizioni esterne.",
  "landing.thermostatManufacturers": "I produttori di termostati sono inoltre supportati per correlare il riscaldamento con le condizioni esterne.",
  "landing.thermostatTitle": "Integrazione smart home",
  "landing.weatherAnalysis": "Analisi meteorologica",
  "landing.weatherAnalysisDescription": "SmartMixin viene fornito con molte visualizzazioni di dati che ti consentono di analizzare i dati meteorologici.",
  "landing.weatherAssistant": "Il tuo assistente meteorologico",
  "landing.weatherAssistantDescription": "Che tu sia interessato alle condizioni meteorologiche attuali, storiche o previste, SmartMixin fornisce numerosi approfondimenti ogni volta che ne hai bisogno.",
  "landing.weatherForecastModels": "Modelli di previsione del tempo",
  "landing.weatherForecastModelsDescription": "SmartMixin fornisce l'accesso ai modelli di previsioni meteorologiche più accurati. Puoi facilmente confrontare le loro previsioni e farti una idea.",
  "landing.weatherMap": "Mappa meteorologica",
  "landing.weatherMapDescription": "Sfoglia la mappa e visualizza che tempo fa ovunque nel mondo.",
  "network.cancelError": "Richiesta cancellata",
  "network.connectionError": "Server non disponibile",
  "network.networkError": "Rete non disponibile",
  "network.serverError": "Qualcosa è andato storto...",
  "network.timeoutError": "Tempo di connessione scaduto",
  "network.unknownError": "Errore sconosciuto",
  "providerHints.ambientWeatherApiKey": "Creata nelle impostazioni del tuo account ambientweather.net.",
  "providerHints.davisApiSecret": "Mostrato solo una volta alla creazione della chiave API V2 — conservalo al sicuro.",
  "providerHints.davisV2ApiKey": "Dalla pagina delle chiavi API V2 di weatherlink.com.",
  "providerHints.ecowittApi": "Dalla pagina API del tuo account Ecowitt.",
  "providerHints.ecowittApp": "La chiave dell'applicazione, anch'essa dal tuo account Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Usa email e password del tuo account My AcuRite — non l'accesso SmartMixin.",
  "providerHints.myAcuriteEmail": "L'email del tuo account My AcuRite — non il tuo accesso SmartMixin.",
  "providerHints.myAcuritePassword": "La password del tuo account My AcuRite.",
  "providerHints.weatherflowToken": "Token a uso personale da tempestwx.com → impostazioni → autorizzazioni dati.",
  "providerHints.wundergroundEditKey": "Usa un'altra chiave",
  "providerHints.wundergroundKey": "Una stringa lunga dalla pagina delle chiavi API del tuo account Weather Underground — non la tua password di wunderground.com.",
  "providerHints.wundergroundKeyExample": "es. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Chiave API verificata",
  "providerHints.wundergroundKeyVerifying": "Verifica della chiave…",
  "providerHints.wundergroundNoStationsNearby": "Nessuna stazione trovata vicino a questa posizione. Prova a inserire direttamente un ID stazione.",
  "providerHints.wundergroundStationId": "Qualsiasi ID di stazione Weather Underground — la tua o una stazione pubblica vicina.",
  "providerHints.wundergroundStationIdExample": "es. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Ottieni la tua chiave API Ambient Weather.",
  "providerIntro.davisStep2": "Ottieni la tua chiave API V2 e segreto API Davis.",
  "providerIntro.ecowittStep2": "Ottieni la tua chiave API e chiave applicazione Ecowitt.",
  "providerIntro.getStarted": "Iniziare",
  "providerIntro.myAcuriteStep2": "Usa email e password del tuo account My AcuRite esistente.",
  "providerIntro.netatmoEnergyStep2": "Accedi a Netatmo quando richiesto — nessuna chiave API necessaria.",
  "providerIntro.netatmoWeatherStep2": "Accedi a Netatmo quando richiesto — nessuna chiave API necessaria.",
  "providerIntro.signupBanner": "Ci siamo quasi — crea il tuo account gratuito SmartMixin per collegare {provider}.",
  "providerIntro.step1": "Accedi al tuo account SmartMixin (NON al login {provider}).",
  "providerIntro.step3EmailPassword": "Inseriscili qui.",
  "providerIntro.step3KeyOrToken": "Incollalo qui.",
  "providerIntro.step3OAuth": "Autorizza SmartMixin nella finestra che appare.",
  "providerIntro.step3Wunderground": "Incolla la tua chiave API, poi seleziona una stazione vicina o inserisci qualsiasi ID stazione.",
  "providerIntro.title": "Collegare {provider}",
  "providerIntro.weatherflowStep2": "Ottieni il tuo token Tempest a uso personale.",
  "providerIntro.wundergroundBrowsePublic": "Non hai una stazione? Sfoglia quelle pubbliche",
  "providerIntro.wundergroundFindNearby": "Trova stazioni vicino a me",
  "providerIntro.wundergroundOrEnterId": "Oppure inserisci un ID stazione",
  "providerIntro.wundergroundStep2": "Ottieni la tua chiave API Weather Underground. Potrai poi collegare qualsiasi stazione — la tua o una pubblica.",
  "reports.agroMeteorology": "Agrometeorologia",
  "reports.analysis": "Analisi",
  "reports.annualCumulativeRainfallComparison": "Confronto precipitazioni annuali cumulative",
  "reports.annualHeatingDurationComparison": "Confronto annuale della durata di riscaldamento",
  "reports.annualHeatingEfficiency": "Efficienza di riscaldamento annuale",
  "reports.annualIndoorComparison": "Comparazione annuale modulo interno",
  "reports.annualIndoorReport": "Riepilogo annuale modulo interno",
  "reports.annualOutdoorComparison": "Comparazione annuale modulo esterno",
  "reports.annualOutdoorReport": "Riepilogo annuale modulo esterno",
  "reports.annualReport": "Riepilogo annuale",
  "reports.annualSolarReport": "Rapporto solare annuale",
  "reports.annualWaterBalance": "Bilancio idrico annuale",
  "reports.annualWaterBalanceCarryOver": "Riporta dall'anno precedente",
  "reports.annualWaterBalanceDescription": "Il bilancio idrico (versione semplificata, vengono utilizzate solo pioggia ed evapotraspirazione) aiuta a gestire l'approvvigionamento idrico",
  "reports.avgHumidity": "Umidità media",
  "reports.avgMaxTemperature": "Media T°max",
  "reports.avgMetric": "Media – {metric}",
  "reports.avgMinTemperature": "Media T°min",
  "reports.avgPressure": "Pressione media",
  "reports.avgTemperature": "Temperatura media",
  "reports.climateNormalPeriodOfRecord": "Periodo di osservazione ({years, plural, one {# anno} other {# anni}})",
  "reports.climateNormals": "Normali climatiche",
  "reports.climateNormalStandardLabel": "Normale standard ({period})",
  "reports.climateTrendPerDecade": "Tendenza della temperatura: {value} per decennio su {years, plural, one {# anno} other {# anni}}",
  "reports.coldestMonthRanking": "{month} più freddo mai registrato",
  "reports.comfortable": "Comfort (45% {lessThan} Umidità ≤ 60%)",
  "reports.cumulativeRainfall": "Precipitazioni cumulative",
  "reports.cumulativeRainfallDescription": "Monitora le precipitazioni totali cumulate nel periodo selezionato.",
  "reports.dailyMaxRainfall": "Max precipitazione giornaliera",
  "reports.dataExport": "Esportazione dati",
  "reports.dataExportXlsxFormatDescription": "Esporta tutti i dati della tua stazione in formato Excel (* .xlsx). Dopo aver fatto clic sul pulsante, dopo pochi minuti riceverai un'email con i dati elaborati.",
  "reports.daysWithFrost": "Giorni di gelo",
  "reports.daysWithHeavyRain": "Giorni di pioggia intensa (≥ {threshold})",
  "reports.daysWithoutThaw": "Giorni senza disgelo",
  "reports.daysWithStrongFrost": "Giorni di grande gelo",
  "reports.emailSent": "Ti è stata inviata un'email",
  "reports.frostDays": "Giorni di gelo",
  "reports.grasslandTemperatureSum": "Somma temperatura prati",
  "reports.grasslandTemperatureSumDescription": "Ripresa sostenibile della vegetazione quando la somma raggiunge {threshold}",
  "reports.growingDegreeDays": "Gradi giorno di crescita",
  "reports.highPressure": "Anticiclone (Pressione media ≥ 1013 mbar)",
  "reports.iceDays": "Giorni di ghiaccio",
  "reports.indoorReport": "Riepilogo modulo interno",
  "reports.keyFacts": "Dati chiave",
  "reports.longestDrySpell": "Periodo secco più lungo",
  "reports.longestRunOfRainyDays": "Serie più lunga di giorni di pioggia",
  "reports.longestRunWithoutRun": "Serie più lunga di giorni senza pioggia",
  "reports.longestWetSpell": "Periodo piovoso più lungo",
  "reports.lowPressure": "Bassa pressione (Pressione media {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Umidità massima",
  "reports.maxMetric": "Massimo – {metric}",
  "reports.maxPressure": "Pressione massima",
  "reports.maxPressureMagnitude24h": "Massima (/24H)",
  "reports.maxTemperature": "Temperatura massima",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Massima (/24H)",
  "reports.minHumidity": "Umidità minima",
  "reports.minMetric": "Minimo – {metric}",
  "reports.minPressure": "Pressione minima",
  "reports.minPressureMagnitude24h": "Minima (/24H)",
  "reports.minTemperature": "Temperatura minima",
  "reports.minTempMagnitude24h": "Minima (/24H)",
  "reports.monthlyHeatingEfficiency": "Efficienza riscaldamento mensile",
  "reports.monthlyIndoorReport": "Riepilogo mensile modulo interno",
  "reports.monthlyOutdoorReport": "Riepilogo mensile modulo esterno",
  "reports.monthlyReport": "Riepilogo mensile",
  "reports.monthlySolarReport": "Rapporto solare mensile",
  "reports.monthlyWindReport": "Riepilogo mensile modulo vento",
  "reports.numberOfDays": "Numero di giorni",
  "reports.onThisDayInHistory": "Accadde oggi",
  "reports.outdoorReport": "Riepilogo modulo esterno",
  "reports.rainfall": "Precipitazioni",
  "reports.rainyDays": "Giorni di pioggia",
  "reports.recordDailyRain": "Giorno più piovoso",
  "reports.recordHigh": "Record di caldo",
  "reports.recordLow": "Record di freddo",
  "reports.recordsAndClimatology": "Record e clima",
  "reports.recordsSince": "Record dal {date}",
  "reports.recordWindGust": "Raffica di vento più forte",
  "reports.relativelyWet": "Abbastanza umido (60 % {lessThan} Umidità ≤ 80 %)",
  "reports.sendEmail": "Invia email",
  "reports.summerDays": "Giorni estivi",
  "reports.tooDry": "Molto secco (Umidità ≤ 45%)",
  "reports.tooWet": "Molto umido (Umidità {greaterThan} 80%)",
  "reports.tropicalNights": "Notti tropicali",
  "reports.warmestMonthRanking": "{month} più caldo mai registrato",
  "reports.waterBalance": "Bilancio idrico",
  "reports.yearsOfData": "{years, plural, one {# anno} other {# anni}} di dati",
  "reports.yearToDateTemperature": "Temperatura da inizio anno",
  "reports.yearToDateTemperatureComparison": "Confronto delle temperature dall'anno in corso",
  "sensors.aqiByChannel": "AQI per canale",
  "sensors.bgtSensors": "Globo nero e WBGT",
  "sensors.cameraFeed": "Telecamera",
  "sensors.compareAqi": "Confronta AQI",
  "sensors.compareHumidity": "Confronta umidità",
  "sensors.compareMoisture": "Confronta umidità del suolo",
  "sensors.comparePm25": "Confronta PM2.5",
  "sensors.compareTemperatures": "Confronta temperature",
  "sensors.depthByChannel": "Profondità per canale",
  "sensors.heatStressExtreme": "Stress termico estremo",
  "sensors.heatStressModerate": "Stress termico moderato",
  "sensors.heatStressNone": "Nessuno stress termico",
  "sensors.heatStressStrong": "Stress termico forte",
  "sensors.heatStressVeryStrong": "Stress termico molto forte",
  "sensors.humidityByChannel": "Umidità per canale",
  "sensors.indoorAirQuality": "Qualità dell'aria interna",
  "sensors.indoorAirQualityPm": "PM2.5 e PM10 AQI",
  "sensors.indoorClimate": "Clima interno",
  "sensors.indoorCo2Levels": "Livelli di CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura e umidità",
  "sensors.last24Hours": "24 ore",
  "sensors.last30Days": "30 giorni",
  "sensors.last7Days": "7 giorni",
  "sensors.leafTemperatureByChannel": "Temperatura delle foglie per canale",
  "sensors.leafWetnessByChannel": "Umidità delle foglie per canale",
  "sensors.lightningSensor": "Fulmine",
  "sensors.moistureByChannel": "Umidità del suolo per canale",
  "sensors.noDataAvailable": "Nessun dato disponibile",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 per canale",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Seleziona canale",
  "sensors.sensorDetailDescription": "Visualizza i dati storici e le tendenze dei canali del sensore.",
  "sensors.sensorHistory": "Cronologia del sensore",
  "sensors.soilConductivityByChannel": "Conducibilità per canale",
  "sensors.soilTemperatureByChannel": "Temperatura del suolo per canale",
  "sensors.strikesToday": "Fulmini oggi",
  "sensors.temperatureByChannel": "Temperatura per canale",
  "sensors.viewChart": "Visualizza grafico",
  "settings.about": "Informazioni",
  "settings.aboutDescription": "Contratto di licenza, informativa sulla privacy",
  "settings.account": "Account",
  "settings.accountDescription": "Profilo, modifica password",
  "settings.accountIntro": "I dati riguardano il tuo account:",
  "settings.accountSection": "Account",
  "settings.appearance": "Aspetto",
  "settings.appearanceDescription": "Tema e opzioni di visualizzazione",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabo",
  "settings.availableServices": "Disponibili",
  "settings.bulgarian": "bulgaro",
  "settings.cannotDisconnectLastAccount": "Non è possibile scollegare l'unico metodo di accesso. Aggiungi prima un altro metodo di accesso.",
  "settings.catalan": "catalano",
  "settings.changeEmail": "Cambia email",
  "settings.changePassword": "Cambia password",
  "settings.chartGestures": "Gesti sui grafici",
  "settings.chartGesturesDescription": "Lo scorrimento sui grafici cambia il periodo di tempo, pizzicando i grafici cambia la scala temporale",
  "settings.connect": "Collega",
  "settings.connected": "Collegato",
  "settings.connectedAccounts": "Account collegati",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Collegati",
  "settings.connectedSince": "Collegato dal {date}",
  "settings.connectionSuccess": "Account {provider} collegato con successo",
  "settings.contactUs": "Contattaci",
  "settings.contactUsDescription": "Ottieni aiuto o invia feedback",
  "settings.croatian": "croato",
  "settings.currentPassword": "Password attuale",
  "settings.czech": "ceco",
  "settings.danish": "danese",
  "settings.dark": "Tema scuro",
  "settings.dataDisplay": "Visualizzazione dati",
  "settings.dateAndTime": "Data e ora",
  "settings.disconnect": "Scollega",
  "settings.disconnectConfirmation": "Sei sicuro di voler scollegare il tuo account {provider}?",
  "settings.disconnectionSuccess": "Account {provider} scollegato con successo",
  "settings.donateButton": "Fai una donazione",
  "settings.donateDescription": "SmartMixin è realizzato da un piccolo team. Se lo trovi utile, puoi sostenerne lo sviluppo con una donazione una tantum di qualsiasi importo. È un regalo — non cambia il tuo piano e non sblocca alcuna funzione.",
  "settings.donateSuccessBody": "La tua donazione aiuta a mantenere attivo SmartMixin e a migliorarlo. Te ne siamo davvero grati.",
  "settings.donateSuccessTitle": "Grazie per il tuo sostegno!",
  "settings.donateTitle": "Sostieni SmartMixin",
  "settings.dutch": "olandese",
  "settings.emailChange": "Cambia indirizzo email",
  "settings.emailChangeConfirmation": "Conferma cambio email",
  "settings.emailChangeFailure": "Il link per il cambio email non è valido o è scaduto.",
  "settings.emailChangeSuccess": "La tua email è stata cambiata con successo in {newEmail}.",
  "settings.emailChangeVerificationSent": "Un'email di verifica è stata inviata al tuo nuovo indirizzo email. Controlla la tua casella di posta e clicca sul link per confermare il cambio.",
  "settings.english": "inglese",
  "settings.forecastModelOrderEmpty": "Nessun ordine salvato — utilizziamo GFS per impostazione predefinita.",
  "settings.forecastModelOrderFreeHint": "I modelli premium richiedono un abbonamento SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "Selezioniamo il primo modello dell'elenco che copre ogni stazione.",
  "settings.forecastModelOrderReset": "Ripristina predefinito",
  "settings.forecastModelOrderTitle": "Modello di previsione predefinito",
  "settings.forecastModels": "Modelli di previsione",
  "settings.forecastModelsDescription": "Riordina per preferenza",
  "settings.french": "francese",
  "settings.german": "tedesco",
  "settings.gestures": "Gesti",
  "settings.greek": "greco",
  "settings.helpCenter": "Centro assistenza",
  "settings.helpCenterDescription": "FAQ e guide",
  "settings.hungarian": "ungherese",
  "settings.integrationsSection": "Integrazioni",
  "settings.italian": "italiano",
  "settings.japanese": "giapponese",
  "settings.korean": "coreano",
  "settings.language": "Lingua",
  "settings.languageDescription": "Lingua preferita",
  "settings.light": "Tema chiaro",
  "settings.newEmailAddress": "Nuovo indirizzo email",
  "settings.newPassword": "Nuova password",
  "settings.newPasswordAgain": "Ripeti la password",
  "settings.norwegian": "norvegese",
  "settings.notConnected": "Non collegato",
  "settings.notificationsSection": "Notifiche",
  "settings.oldPassword": "Vecchia password",
  "settings.ongoingNotificationEnabled": "Attiva notifica permanente",
  "settings.ongoingNotificationMetrics": "Metriche visualizzate",
  "settings.ongoingNotificationMetricsHint": "Trascina per riordinare le metriche selezionate",
  "settings.ongoingNotificationPermissionRequired": "È richiesto il permesso per le notifiche",
  "settings.ongoingNotificationStation": "Stazione meteo",
  "settings.passwordChange": "Modifica password",
  "settings.polish": "polacco",
  "settings.portuguese": "portoghese",
  "settings.preferencesSection": "Preferenze",
  "settings.premium": "Premium",
  "settings.premiumActive": "Attivo",
  "settings.premiumAnnualThenPrice": "Poi 9,99 €/anno",
  "settings.premiumAnnualTrialInfo": "Inizia con una prova gratuita di {days} giorni",
  "settings.premiumCurrentPlan": "Piano attuale",
  "settings.premiumDescription": "Sblocca funzioni premium",
  "settings.premiumDownloadApp": "Scarica l'app per abbonarti:",
  "settings.premiumExpiresOn": "Rinnovo il {date}",
  "settings.premiumFreePlan": "Gratuito",
  "settings.premiumInactive": "Non abbonato",
  "settings.premiumManageWebSubscription": "Gestisci il tuo abbonamento, aggiorna il metodo di pagamento o annulla.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Annuale — 9,99 €/anno",
  "settings.premiumSubscribedOn": "Abbonato su {platform}",
  "settings.premiumSubscribeMonthly": "Mensile — 1,99 €/mese",
  "settings.premiumSubscribeOnWeb": "Abbonati ora per sbloccare tutte le funzionalità premium.",
  "settings.premiumSubscriptionSuccess": "Il tuo abbonamento è stato attivato! Goditi tutte le funzionalità premium.",
  "settings.premiumSubscriptionSuccessTitle": "Benvenuto in Premium!",
  "settings.premiumWebappNotice": "Gli abbonamenti possono essere acquistati solo tramite l'app mobile SmartMixin su iOS o Android.",
  "settings.privacyPolicy": "Informativa sulla privacy",
  "settings.profile": "Profilo",
  "settings.russian": "russo",
  "settings.serbian": "serbo",
  "settings.settings": "Impostazioni",
  "settings.slovak": "slovacco",
  "settings.smallDecimals": "Decimali piccoli",
  "settings.smallDecimalsDescription": "Mostra le cifre decimali in una dimensione più piccola",
  "settings.socialConnectionsIntro": "Collega i tuoi account social per un accesso rapido. Puoi collegare o scollegare gli account in qualsiasi momento.",
  "settings.spanish": "spagnolo",
  "settings.statusBarWidget": "Widget barra di stato",
  "settings.statusBarWidgetDescription": "Dati meteo sempre visibili",
  "settings.subscriptionSection": "Abbonamento",
  "settings.supportSection": "Supporto",
  "settings.swedish": "svedese",
  "settings.systemTheme": "Tema di sistema",
  "settings.termsOfService": "Termini di servizio",
  "settings.turkish": "turco",
  "settings.ukrainian": "ucraino",
  "settings.units": "Unità",
  "settings.unitsDescription": "Unità di misura visualizzate all'interno dell'applicazione",
  "settings.update": "Aggiorna",
  "settings.updateYourProfile": "Aggiorna il tuo profilo",
  "settings.weatherServices": "Servizi meteo",
  "settings.weatherServicesConnected": "{count, plural, =0 {Nessun servizio connesso} one {# servizio connesso} other {# servizi connessi}}",
  "settings.weatherServicesDescription": "Collega Netatmo, Davis, Weatherflow e altro",
  "settings.windDirectionConvention": "Freccia direzione del vento",
  "settings.windDirectionConventionDescription": "Scegli come vengono visualizzate le frecce della direzione del vento",
  "settings.windDirectionMeteorological": "Direzione di origine",
  "settings.windDirectionMeteorologicalDescription": "La freccia indica da dove viene il vento (convenzione meteorologica)",
  "settings.windDirectionOceanographic": "Direzione del flusso",
  "settings.windDirectionOceanographicDescription": "La freccia indica dove soffia il vento (convenzione oceanografica)",
  "units.absolutePressure": "Pressione assoluta",
  "units.airDensity": "Densità dell'aria",
  "units.airGap": "Distanza d'aria",
  "units.apparentTemperature": "Temperatura apparente",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Media",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Temp. globo nero",
  "units.boilerOn": "Caldaia ON",
  "units.co2": "CO2",
  "units.conductivity": "Conducibilità",
  "units.coolingDegreeDays": "Gradi giorno di raffrescamento",
  "units.dailyHeatingDuration": "Durata del riscaldamento giornaliera",
  "units.dailyPrecipitation": "Precipitazione giornaliera",
  "units.dailyRain": "Pioggia giornaliera",
  "units.degreeDay": "Grado Giorno",
  "units.degreeDayShort": "GG",
  "units.depth": "Profondità",
  "units.depthSensors": "Sensori di profondità",
  "units.dewPoint": "Punto di rugiada",
  "units.distance": "Distanza",
  "units.downTrend": "Tendenza al ribasso",
  "units.E": "E",
  "units.E_long": "Est",
  "units.ENE": "ENE",
  "units.ENE_long": "Est-Nord-Est",
  "units.ESE": "ESE",
  "units.ESE_long": "Est-Sud-Est",
  "units.ET": "Evapotraspirazione",
  "units.ETshort": "ET",
  "units.feelLike": "Percepita",
  "units.feelsLike": "Percepita",
  "units.footMile": "Piedi, miglia",
  "units.frostPoint": "punto di gelo",
  "units.gust": "Raffica",
  "units.heatIndex": "Indice di calore",
  "units.heatingDegreeDays": "Gradi giorno di riscaldamento",
  "units.heatingPower": "Potenza di riscaldamento",
  "units.humidex": "Humidex",
  "units.humidity": "Umidità",
  "units.inch": "Pollici",
  "units.inchOfMercury": "Pollici di mercurio",
  "units.kilometerPerHour": "Chilometri all'ora",
  "units.knot": "Nodi",
  "units.last12Hours": "Ultime 12 ore",
  "units.last24Hours": "Ultime 24 ore",
  "units.last3Hours": "Ultime 3 ore",
  "units.last6Hours": "Ultime 6 ore",
  "units.lastHour": "Ultima ora",
  "units.lastLightningImpact": "Ultima fulminazione",
  "units.lastMeasure": "Ultima misura",
  "units.leafSensors": "Sensore umidità fogliare",
  "units.leafWetness": "Umidità fogliare",
  "units.lightningDistance": "Distanza",
  "units.lightningStrikeCount": "Conteggio dei fulmini",
  "units.lightningStrikeDistance": "Distanza del fulmine",
  "units.max": "Max.",
  "units.max_gust": "Raffica Max.",
  "units.max_wind": "Vento Max.",
  "units.meterKilometer": "Metri, chilometri",
  "units.meterPerSecond": "Metro al secondo",
  "units.milePerHour": "Miglio orario",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimetri",
  "units.millimeterOfMercury": "Millimetri di mercurio",
  "units.min": "Min.",
  "units.N": "N",
  "units.N_long": "Nord",
  "units.NE": "NE",
  "units.NE_long": "Nord-Est",
  "units.NNE": "NNE",
  "units.NNE_long": "Nord-Nord-Est",
  "units.NNW": "NNW",
  "units.NNW_long": "Nord-Nord-Ovest",
  "units.noise": "Rumore",
  "units.normalizedHeatingCoefficient": "Coefficiente di riscaldamento normalizzato",
  "units.NW": "NW",
  "units.NW_long": "Nord-Ovest",
  "units.O3": "Ozono",
  "units.PM_1": "PM 1",
  "units.PM_10": "PM 10",
  "units.PM_2P5": "PM 2,5",
  "units.precipitation": "Precipitazioni",
  "units.pressure": "Pressione",
  "units.rain": "Pioggia",
  "units.rainRate": "Intensità di pioggia",
  "units.referenceTemperature": "Temperatura di riferimento",
  "units.relativePressure": "Pressione relativa",
  "units.S": "S",
  "units.S_long": "Sud",
  "units.SE": "SE",
  "units.SE_long": "Sud-Est",
  "units.setPoint": "T° Impostata",
  "units.snow": "Neve",
  "units.snowfall": "Nevicata",
  "units.soilMoisture": "Umidità del suolo",
  "units.soilSensors": "Sensori suolo",
  "units.solarEnergy": "Energia solare",
  "units.solarRadiation": "Radiazione solare",
  "units.speed": "Velocità",
  "units.SSE": "SSE",
  "units.SSE_long": "Sud-Sud-Est",
  "units.SSW": "SSW",
  "units.SSW_long": "Sud-Sud-Ovest",
  "units.stableTrend": "Stabile",
  "units.sum": "cumulativo",
  "units.SW": "SW",
  "units.SW_long": "Sud-Ovest",
  "units.temperature": "Temperatura",
  "units.temperatureAndHumiditySensors": "Sensori di temperatura e umidità",
  "units.temperatureSensors": "Sensori di temperatura e umidità",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Oggi",
  "units.upTrend": "Tendenza al rialzo",
  "units.uv": "UV",
  "units.visibility": "Visibilità",
  "units.W": "W",
  "units.W_long": "Ovest",
  "units.wetBulbGlobeTemperature": "Temperatura del globo a bulbo umido",
  "units.wetBulbTemperature": "Temp. bulbo umido",
  "units.wind": "Vento",
  "units.windChill": "Raffreddamento da vento",
  "units.windDirection": "Direzione del vento",
  "units.windRun": "Corsa del vento",
  "units.windRunDescription": "La corsa del vento è la distanza totale percorsa dal vento in un periodo di tempo",
  "units.WNW": "WNW",
  "units.WNW_long": "Ovest-Nord-Ovest",
  "units.WSW": "WSW",
  "units.WSW_long": "Ovest-Sud-Ovest"
}
